module.exports = __webpack_public_path__ + "static/media/image_03.53671814.png";